import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import ReplayIcon from '@mui/icons-material/Replay'
import type { GamePhase, SoldVehicle } from '../types'
import VehicleSnapshot from './VehicleSnapshot'
import PriceBillboard from './PriceBillboard'
import { extractVehiclePrice } from '../hooks/useJusteEnchereGame'
import { neonText, tvGradientBackground, TV_COLORS, buzzerButton } from '../designSystem'

type GameSummaryProps = {
  phase: GamePhase
  onQuit: () => void
  finalVehicle: SoldVehicle | null
}

const GameSummary = ({
  phase,
  onQuit,
  finalVehicle,
}: GameSummaryProps) => {
  const success = phase === 'success'
  const reachedFinal = Boolean(finalVehicle)
  const statusLabel = success ? 'Bravo !' : 'Partie terminée'
  const helperText = success
    ? 'Tu as trouvé le juste prix, prêt pour une nouvelle partie ?'
    : 'Tu feras mieux la prochaine fois, retente ta chance !'
  const showFinalVehicle = reachedFinal && finalVehicle
  const finalPrice = showFinalVehicle ? extractVehiclePrice(finalVehicle) : null

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 560,
        borderRadius: 3,
        p: 3,
        textAlign: 'center',
        color: '#fff',
        ...tvGradientBackground,
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontFamily: 'Bebas Neue', letterSpacing: 3, mb: 1, ...neonText(TV_COLORS.yellow) }}
      >
        {statusLabel}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.85)' }}>
        {helperText}
      </Typography>

      <Stack spacing={1.2} sx={{ mb: 3 }}>
        {showFinalVehicle ? (
          <Box sx={{display: 'flex', flexDirection: 'column', gap:2}}>
            <PriceBillboard
              label="Prix adjugé"
              value={finalPrice}
              highlight
            />
            <VehicleSnapshot
              vehicle={finalVehicle}
            />
          </Box>
        ) : null}
      </Stack>

      <Stack direction="row" spacing={1} justifyContent="center">
        <Button
          variant="contained"
          startIcon={<ReplayIcon />}
          onClick={onQuit}
          sx={{
            ...buzzerButton('higher', { base: TV_COLORS.blue, dark: TV_COLORS.violet }),
            maxWidth: 200,
          }}
        >
          Rejouer / Quitter
        </Button>
      </Stack>
    </Box>
  )
}

export default GameSummary
